<div class="u-paddingTop-32" fxLayout="column" fxLayoutGap="16px">
  <nz-breadcrumb fxLayout="row">
    <nz-breadcrumb-item>
      <a
        [routerLink]="['/admin/members']"
        class="color-grey-300 u-cursor-pointer text-body-2"
        i18n="@@global.manageMembers"
        >Manage members</a
      >
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <a
        [routerLink]="['/admin/members/import-membership-file']"
        class="color-grey-300 u-cursor-pointer text-body-2"
        i18n="@@csvImport.breadCrumbs.uploadMembershipFile"
        >Upload membership file</a
      >
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>{{ fileName }}</nz-breadcrumb-item>
  </nz-breadcrumb>
  <nz-steps [nzCurrent]="2" class="u-padding-16-0" nzSize="small">
    <nz-step
      nzTitle="Upload file"
      i18n-nzTitle="@@csvImport.steps.uploadFile"
    ></nz-step>
    <nz-step
      nzTitle="Review mappings"
      i18n-nzTitle="@@csvImport.steps.reviewMappings"
    ></nz-step>
    <nz-step
      nzTitle="Approve member updates"
      i18n-nzTitle="@@csvImport.steps.approveMemberUpdates"
    ></nz-step>
  </nz-steps>
  @if (showErrorBanner) {
    <app-automated-user-management-banner
      [description]="banner.description"
      [imageColor]="banner.imageColor"
      [imageName]="banner.imageName"
      [title]="banner.title"
      (action)="bannerAction(banner.type)"
    >
    </app-automated-user-management-banner>
  }
  <div *ngFor="let action of actionTypes">
    <div class="bg-color-white u-card u-padding-16 mat-elevation-z1">
      <div fxLayout="row">
        <div fxLayout="row" fxLayoutGap="16px">
          <div fxLayout="column" fxLayoutAlign="start start">
            @switch (state[action]?.actionQueue?.status) {
              @case ('completed') {
                <mat-icon
                  class="material-symbols-filled u-width-100 md-24 color-teal-700"
                  >check_circle</mat-icon
                >
              }
              @case ('semi-completed') {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-24 color-teal-700"
                  >check_circle</mat-icon
                >
              }
              @case ('dismissed') {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-24 color-orange-300"
                  >check_circle</mat-icon
                >
              }
              @case ('initializing') {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-24 color-grey-300"
                  style="animation: spin 2s linear infinite"
                  >autorenew</mat-icon
                >
              }
              @case ('error') {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-24 color-orange-300"
                  >cancel</mat-icon
                >
              }
              @case ('in-progress') {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-24 color-teal-700"
                  style="animation: spin 2s linear infinite"
                  >autorenew</mat-icon
                >
              }
              @case ('pending') {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-24 color-grey-300"
                  >check_circle</mat-icon
                >
              }
              @default {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-24 color-grey-300"
                  style="animation: spin 2s linear infinite"
                  >autorenew</mat-icon
                >
              }
            }
          </div>
          <div fxLayout="column">
            <div fxLayout="row" fxLayoutGap="4px">
              <b>{{ actionQueueTitles[action] }}</b>
              @if (
                'in-progress' === state[action].actionQueue?.status ||
                'semi-completed' === state[action].actionQueue?.status
              ) {
                <div class="text-caption color-grey-300">
                  ({{ state[action].completedActionItemsCount }}/{{
                    state[action].activeActionItems
                  }})
                </div>
              }
              @if ('completed' === state[action].actionQueue?.status) {
                <div class="text-caption color-grey-300">
                  ({{ state[action].completedActionItemsCount }}/{{
                    state[action].activeActionItems
                  }})
                </div>
              }
              @if ('semi-completed' === state[action].actionQueue?.status) {
                <mat-icon
                  class="material-symbols-outlined u-width-100 md-16 color-orange-300"
                  nz-tooltip="Some of your actions were incomplete"
                  i18n-nz-tooltip="
                    @@csvActionItemQueues.incompleteQueue.tooltip"
                  >info</mat-icon
                >
              }
            </div>
            <p>
              {{ actionQueueDescriptions[action] }}
            </p>
          </div>
        </div>
        <div fxFlex="auto" fxLayoutAlign="end center">
          @switch (state[action]?.actionQueue?.status) {
            @case ('semi-completed') {
              <button
                (click)="
                  openActionItemDrawer(
                    action,
                    state[action].actionQueue?._id,
                    state[action].actionQueue?.status
                  )
                "
                color="primary"
                mat-stroked-button
                i18n="@@global.view"
              >
                View
              </button>
            }
            @case ('completed') {
              <button
                (click)="
                  openActionItemDrawer(
                    action,
                    state[action].actionQueue?._id,
                    state[action].actionQueue?.status
                  )
                "
                color="primary"
                mat-stroked-button
                i18n="@@global.view"
              >
                View
              </button>
            }
            @case ('initializing') {
              <button
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
                mat-stroked-button
              >
                <mat-icon
                  class="color-grey-300"
                  style="animation: spin 2s linear infinite"
                  >autorenew</mat-icon
                >
                <span
                  class="color-grey-300"
                  i18n="@@csvActionItemQueues.prepatingActions"
                  >Preparing actions</span
                >
              </button>
            }
            @case ('pending') {
              <button
                [disabled]="0 === state[action].actionItems.length"
                (click)="
                  openActionItemDrawer(
                    action,
                    state[action].actionQueue?._id,
                    state[action].actionQueue?.status
                  )
                "
                color="primary"
                mat-stroked-button
                i18n="@@global.review"
              >
                Review
              </button>
            }
            @case ('in-progress') {
              <button
                [disabled]="true"
                color="primary"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
                mat-stroked-button
              >
                <mat-icon
                  class="color-grey-300"
                  style="animation: spin 2s linear infinite"
                  >autorenew</mat-icon
                >
                <span
                  class="color-grey-300"
                  i18n="@@csvActionItemQueues.runningActions"
                  >Running actions</span
                >
              </button>
            }
            @case ('error') {
              <button
                [disabled]="true"
                color="primary"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
                mat-stroked-button
              >
                <span class="color-grey-300" i18n="@@global.view">View</span>
              </button>
            }
            @default {
              <button
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
                mat-stroked-button
              >
                <mat-icon
                  class="color-grey-300"
                  style="animation: spin 2s linear infinite"
                  >autorenew</mat-icon
                >
                <span
                  class="color-grey-300"
                  i18n="@@csvActionItemQueues.prepatingActions"
                  >Preparing actions</span
                >
              </button>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
